import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export type CancelWarningType = 'danger' | 'info'

interface CancelWarningBlockProps {
  type: CancelWarningType
  title: string
  description: string
}

export const CancelWarningBlock: FC<CancelWarningBlockProps> = ({
  type,
  title,
  description,
}) => {
  return (
    <Paper
      padding={[12]}
      radius="12px"
      className={clsx(s.warningBlock, s[type])}
    >
      <div className={s.warningContent}>
        <AppIcon
          id={AllIcons.INFO_TRIANGLE}
          width={24}
          height={24}
          className={s.warningIcon}
        />
        <div className={s.warningText}>
          <p className={clsx('bold-12', s.warningTitle)}>{title}</p>
          <p className={clsx('medium-12', s.warningDescription)}>
            {description}
          </p>
        </div>
      </div>
    </Paper>
  )
}
